import { Navigate, createFileRoute } from "@tanstack/react-router";
import { useQuery } from "convex/react";
import { LandingPage } from "@/components/landing/landing-page";
import { ShellSkeleton } from "@/components/shell/app-shell";
import { lastVisited } from "@/components/shell/workspace-context";
import { api } from "@/lib/api";
import { mayHaveSession } from "@/lib/auth-client";
import { useAuthStatus } from "@/lib/use-auth-status";

export const Route = createFileRoute("/")({
  component: Home,
});

/**
 * The landing page for visitors, and for anyone signed in the way to where
 * they belong.
 */
function Home() {
  const status = useAuthStatus();
  const workspaces = useQuery(api.workspaces.listMine, status === "signedIn" ? {} : "skip");

  if (status === "signedOut") return <LandingPage />;
  // A browser with no stored session is a visitor: show the page now rather
  // than after the session check. Same element as above, so it stays mounted.
  if (status === "loading") return mayHaveSession() ? <ShellSkeleton /> : <LandingPage />;
  if (workspaces === undefined) return <ShellSkeleton />;
  if (workspaces.length === 0) return <Navigate to="/new" replace />;

  const last = lastVisited.workspace();
  const target = workspaces.find((workspace) => workspace.slug === last) ?? workspaces[0];
  return (
    <Navigate to="/$workspaceSlug" params={{ workspaceSlug: target.slug }} replace />
  );
}
